export const hseStatus = ["New", "HSE Confirmed", "Closed"];
export const changesList = ["New Projects", "Process Changes", "Equipment Changes", "Chemical Changes", "Product Changes", "De-Commissioning", "Layout Changes"];

export const GRID_CONFIG = {

    noDataText: "No Data",
    showBorders: true,
    rowAlternationEnabled: true,
    allowColumnReordering: true,
    allowColumnResizing: true,
    columnResizingMode: "widget",
    columnAutoWidth: true,
    columnChooser: {
        enabled: true,
        allowSearch: true,
        mode: "select"
    },
    editing: {
        mode: "popup",
        allowUpdating: true,
        allowAdding: false,
        allowDeleting: true,
        useIcons: true,

    },

    headerFilter: {
        visible: true
    },
    sorting: {
        mode: "multiple"
    },
    grouping: {
        contextMenuEnabled: true
    },
    searchPanel: {
        visible: true
    },
    filterRow: {
        visible: true,
        applyFilter: "auto"
    },

    onToolbarPreparing: function (e) {
        var dataGrid = e.component;
        var toolbarItems = e.toolbarOptions.items;
        // Adds a new item
        toolbarItems.unshift({
            location: "before",
            template: "Email Schedules"
        }, {
            location: "after",
            widget: "dxButton",
            options: {
                icon: "refresh",
                hint: "Refresh",
                onClick: function () {
                    dataGrid.refresh();
                }
            }
        });
    }

}